import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

// 部门管理
export default class departmentState extends baseState {
    // 列表
    @observable list = {};
    @action
    setList(data) {
        this.list = { records: data };
    }
    getList = (data) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.LIST,
            setState: this.setList,
            method: 'get',
            data
        });
    };
    // 详情
    @observable detail = {};
    @action
    setDetail(data) {
        this.detail = data;
    }
    getDetail = (id) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.DETAIL + id,
            setState: this.setDetail,
            method: 'get',
        });
    };

    insert = data => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.INSERT,
            data,
        });
    };

    update = data => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.UPDATE,
            data,
        });
    };

    delete = (id) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.DELETE + id,
        });
    };

    // 资金往来记录
    @observable balanceLog = {};
    @action
    setBalanceLog(data) {
        this.balanceLog = data;
    }
    getBalanceLog = (data) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.BALANCE_LOG,
            setState: this.setBalanceLog,
            method: 'get',
            data,
        });
    };
    // 机型组
    @observable channels = [];
    @action
    setChannels(data) {
        this.channels = data || [];
    }
    getChannels = () => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.CHANNEL,
            setState: this.setChannels,
            method: 'get',
        });
    };

    // 部门列表
    @observable all = [];
    @action
    setAll(data) {
        this.all = data || [];
    }
    getAll = (data) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.ALL,
            setState: this.setAll,
            method: 'get',
            data,
        });
    };

    // 资金相关 ==========
    getBalance = (id) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.GET_BALANCE + id,
            method: 'get',
        });
    };
    addBalance = (data) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.ADD_CONFIG_BALANCE,
            data
        });
    };
    updateBalance = (data) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.UPDATE_BALANCE,
            data
        });
    };
    // 资金关联配置
    @observable relConfig = [];
    @action
    setRelConfig(data) {
        this.relConfig = data;
    }
    getRelConfig = (data) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.REL_CONFIG_BALANCE,
            setState: this.setRelConfig,
            method: 'get',
            data,
        });
    };
    // 资金未关联配置
    @observable noRelConfig = [];
    @action
    setNoRelConfig(data) {
        this.noRelConfig = data;
    }
    getNoRelConfig = (data) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.NO_REL_CONFIG_BALANCE,
            setState: this.setNoRelConfig,
            method: 'get',
            data,
        });
    };

    addRelConfig = (data) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.ADD_REL_CONFIG_BALANCE,
            data,
        });
    };
    delRelConfig = (data) => {
        return this.fetch({
            url: apiUrl.PERMISSION.DEPARTMENT.DEL_REL_CONFIG_BALANCE,
            data,
        });
    };
}
